const pixelsCategories = ["TARGETING","STRICTLY_NECESSARY"];

export { pixelsCategories };